/* eslint-disable */
import {
  GET_ALL_RISK_CRITERIAS_CONFIGURATION,
  GET_ALL_RISK_CRITERIAS,
  GET_RISK_PROFILES,
  GET_QUESTIONS_BY_CRITERIA,
  GET_QUESTIONS_CONFIGURATION,
  GET_ALL_QUESTIONS_CONFIGURATION,
} from "../actionTypes";

const initialStateRisk: RiskState = {
  risk_criterias_configurations: {},
  risk_questions: [],
  risk_questions_configurations: [],
};

export const RiskReducer = (
  state: RiskState = initialStateRisk,
  action: RiskActions
) => {
  switch (action.type) {
    case GET_RISK_PROFILES:
      return {
        ...state,
        risk_profile_list: action.payload,
      };
    case GET_ALL_RISK_CRITERIAS_CONFIGURATION:
      return {
        ...state,
        risk_criterias_configurations: action.payload,
      };
    case GET_ALL_RISK_CRITERIAS:
      return {
        ...state,
        risk_criterias: action.payload,
      };
    case GET_QUESTIONS_BY_CRITERIA:
      return {
        ...state,
        risk_questions_by_criteria: action.payload,
      };
    case GET_ALL_QUESTIONS_CONFIGURATION:
      return {
        ...state,
        risk_questions: action.payload,
      };
    case GET_QUESTIONS_CONFIGURATION:
      return {
        ...state,
        risk_questions_configurations: state.risk_questions_configurations.concat(
          action.payload
        ),
      };
    default:
      return {
        ...state,
      };
  }
};
